import ServicesList from "../../Components/Services/ServicesList";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import Pagebanner from "../../layout/Banner";
import { Helmet } from "react-helmet";

const PracticeAreas = () => {
  return (
    <>
      <Helmet>
        <title>Practice Areas - Advocate Saurav Dagar Chambers</title>
        <meta
          name="description"
          content="Explore the diverse practice areas of Advocate Saurav Dagar Chambers. Expert legal solutions in civil, criminal, corporate, and family law delivered by experienced attorneys."
        />
        <meta
          name="keywords"
          content="Advocate Saurav Dagar, Law Firm, Practice Areas, Civil Law, Criminal Law, Corporate Law, Family Law, Attorneys"
        />
        <noscript>
          Please enable JavaScript to view this page properly.
        </noscript>
      </Helmet>
      <Header />
      <Pagebanner title="Practice Areas" subtitle="Our Practice Areas" />
      <ServicesList />
      <Footer />
    </>
  );
};
export default PracticeAreas;
